import "./works.scss";

import Card from "../../../src/components/work-card/card/Index";

const Works = () => {
  return (
    <section id="works" className="works">
      <Card />
    </section>
  );
};

export default Works;
